var $e99d9c77cf4a7b4f$exports = {};
$e99d9c77cf4a7b4f$exports = {
    "removeButtonLabel": `Ukloni`,
    "removeDescription": `Pritisnite Obri\u{161}i da biste uklonili oznaku.`
};


export {$e99d9c77cf4a7b4f$exports as default};
//# sourceMappingURL=sr-SP.mjs.map
